import DocumentPage from "../../../../invoice/DocumentPage";
import { verifactuCreditNoteConfig } from "./config";

const VerifactuCreditNote = () => (
  <DocumentPage config={verifactuCreditNoteConfig} />
);

export default VerifactuCreditNote;